const initialState = {
  status: "invalid",
  data: {
    absent_pickers_gdn_packs: [],
    absent_packers_gdn_packs: [],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "ALERTS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "ALERTS_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
      };
    case "ALERTS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
